<!-- <p class="component my-1">{{'Dashboard'|translate}} <span class="trackcolor">/ {{'Licenses'|translate}}</span></p> -->
<app-common-modal-popup>
    <div class="" modelheadertext *ngIf="gridMode">{{'Task List'|translate}}</div>
    <div class="" modelheadertext *ngIf="addMode">{{superAdmin ? ('Add license'|translate):('Purchase license'|translate)}}</div>
        <div class="container-fluid" modeldata *ngIf="gridMode">
            <div class="row p-0">
                <div class="card p-0 headcard">
                    <!-- HEADER WITH ADD POI BTNS -->
                    <div class="bg-light">
                     
                                <!-- <div class="input-group searchvehicles bg-white">
    
                                    <input (keyup)="page =1" formControlName="searchValue" name="searchValue"
                                        type="text" class="form-control reportsbox" placeholder="{{'Search'|translate}}"
                                        autocomplete="off" />
    
                                    <div class="input-group-append">
                                        <button class="btn" type="button" style="padding: 1vh 1.4vh 1.1vh 1.4vh">
                                            <img (click)="searchData()" src="/assets/icons/searchicon.png" alt="search"
                                                style="width: 2.3vh" />
                                        </button>
                                    </div>
                                </div> -->
                                <div class="card-header flex_row_center_spacebetween">
                                  
                                  <!-- <div class="d-flex align-items-center" *ngIf="!isClient">
                                    <span  class="to ms-2">Select Client</span>
                                    <select
                                      [ngStyle]="{ width: '150px' }"
                                      class="form-select me-2  taskspanel"
                                      [(ngModel)]="clientName"          
                                      (change)="onClientSelect()"  
                                    >
                                  
                                    <option value="0" class="select_options">Select</option>
                                    <option value="{{client.name}}" class="select_options" *ngFor="let client of clientList">
                                        {{ client.name }}
                                      </option>          
                                    </select>
                                  </div>
                                   

                                <div class="d-flex align-items-center ms-2" *ngIf="!isClient">
                                    <span class="to ">Select Driver</span>
                                    <select
                                      [ngStyle]="{ width: '150px' }"
                                      class="form-select me-2  taskspanel"
                                      [(ngModel)]="driverName"          
                                      (change)="onDriverSelect()"
                                    >
                                    <option value="0" class="select_options"  >Select</option>
                                    <option value="{{driver.name}}" class="select_options" *ngFor="let driver of driverList">
                                        {{ driver.name }}
                                      </option>         
                                    </select> 
                                </div> -->
                                    <div class="d-flex align-items-center ms-2 ">

                                        <span class="to ">Select Status</span>
                                        <select
                                          [ngStyle]="{ width: '150px' }"
                                          class="form-select me-2   taskspanel"
                                          (change)="statusChange($event)"
                                        >
                                        <option value="0" class="select_options" >Select</option>
                                        <option value="unassigned" class="select_options">Unassigned</option>
                                        <option value="assigned" class="select_options">Assigned</option>
                                        <option value="started" class="select_options">Started</option>
                                        <option value="acknowledged" class="select_options">Acknowledged</option>
                                        <option value="completed" class="select_options">Completed</option>
                                                
                                        </select> 
                                    </div>
                                   
                                    <!-- <span class="to">Select Supervisor</span>
                                    <select
                                      [ngStyle]="{ width: '150px' }"
                                      class="form-select me-2 ms-2"
                                      [(ngModel)]="supervisorName"          
                                      (change)="onSupervisorSelect()"
                                    >
                                     <option value="" class="select_options" disabled hidden>Select</option>
                                    <option value="{{supervisor.name}}" class="select_options" *ngFor="let supervisor of supervisorList">
                                        {{ supervisor.name }}
                                      </option>         
                                    </select> -->
                                    <div class="flex_row_center_spacebetween">
                                        <span class="to p-2">{{'from'|translate}}</span>
                                        <input
                                        type="text"
                                        [(ngModel)]="fromdateP"
                                        bsDatepicker
                                        [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }"
                                        style="height: 5.2vh; border-radius: 5px; width: 137px"
                                         placeholder="dd/mm/yyyy"
                                      />
                                     
                                      <span class="to p-2">{{'to'|translate}}</span>
                                      <input 
                                      type="text"       
                                        [(ngModel)]="todateP"
                                        bsDatepicker
                                        [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }"
                                        style="height: 5.2vh; border-radius: 5px; width: 137px"
                                        placeholder="dd/mm/yyyy"
                                      />
  
                                      </div>
                                      <select
                                      [ngStyle]="{ width: '200px', 'margin-left': '10px' }"
                                      class="form-select taskspanel"
                                      [(ngModel)]="dayType"
                                      name="dayType"
                                      (change)="setReportsDate()"
                                    >
                                      <option value="Today" class="select_options">Today</option>
                                      <option value="Yesterday" class="select_options">Yesterday</option>
                                      <option
                                        value="Week"
                                        class="select_options"
                                      >
                                        Week
                                      </option>
                                      <option
                                        value="Month"
                                        class="select_options"
                                      >
                                        Month
                                      </option>
                                      <option
                                        value="Last Month"
                                        class="select_options"
                                      >
                                        Last Month
                                      </option>
                                      <option value="Custom" class="select_options">Custom</option>
                                    </select>
                                    <select
                                      style="width:185px !important;margin-left: 10px;height: 5.2vh !important;"
                                      class="form-select selectimportant"
                                      [(ngModel)]="reportTypeFilter"
                                      *ngIf="reportsName == 'Events'"
                                    >
                                      <option value=""></option>
                                      <option value="{{t.type}}" *ngFor="let t of typeFilterData">{{t.type}}</option>          
                                    </select>
                                    
                                    <div *ngIf="reportsName == 'Route'" class="form-control-mt-select">
                                      
                                        <!-- <mat-label>Colunmn</mat-label> -->
                                        <mat-select placeholder="Colunmn"  [(ngModel)]="colunmnList" multiple class="d-flex align-items-center justify-content-center flex-column">
                                          <mat-option *ngFor="let item of masterColumnList" [value]="item.value">{{item.label}}</mat-option>
                                        </mat-select>
                                      
                                    </div>
                                    <div
                                    class="flex-grow-1 p-2"
                                      id="refresh_downloadBtn"
                                      style="
                                        display: flex;
                                        flex-direction: row;
                                        justify-content: end;
                                        
                                      "   
                                    >
                                    
                                      <div style="display: flex; flex-direction: row">
                                        <button type="button" class="btn btn-info me-2" (click)="filteredData()">Search</button>
                                        <div class="dropdown">
                                          <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                                            Download
                                          </button>
                                          <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                            <li>
                                              <button type="button" matTooltip="Excel Download" class="btn btn-success w-100 d-flex align-items-center justify-content-center" *ngIf="reportsName != 'Trips'" (click)="downloadData('xlsx')">
                                                <i class="bi bi-file-earmark-excel" style="color: #FFF; font-size: 24px; margin-right: 5px;"></i> Excel
                                              </button>
                                              <app-export-data *ngIf="reportsName == 'Trips'" [selectedPage]="'Trips'" [dataList]="taskListData"></app-export-data>
                                            </li>
                                            <li style="margin-top: 5px;">
                                              <button type="button" matTooltip="PDF Download" class="btn btn-success w-100 d-flex align-items-center justify-content-center" (click)="downloadData('pdf')">
                                                <i class="bi bi-filetype-pdf" style="color: #FFF; font-size: 24px; margin-right: 5px;"></i> PDF
                                              </button>                  
                                            </li>                   
                                          </ul>
                                        </div>
                                        
                                        <!-- <span class="px-2" (click)="onSelectVehicle(null)"
                                          ><img class="small-img"
                                            src="/assets/icons/report_refresh_gray.png"
                                            alt="refresh"
                                            style="width: 96%"
                                        /></span>
                                        <span *ngIf="reportsName != 'Trips'" class="" (click)="downloadData('xlsx')">
                                          <img
                                           class="small-img"
                                            src="/assets/icons/report_download_gray.png"
                                            alt="download xlsx"
                                            style="width: 96%"
                                          />
                                        </span> -->
                                        
                                        
                                      </div>
                                    </div>
                                  </div> 
                            <div>
                                <!-- <button 
                                class="addbtns d-flex align-items-center p-2"                                
                                title="{{'Add license'|translate}}">
                                <i class="bi bi-union me-2 text-secondary"></i>
                                <span>Merge Connected Task</span>
                            </button>  -->
                            </div>
                            <!-- <button *ngIf="superAdmin; else purchaseLicenseBtn" 
                                class="addbtns d-flex align-items-center p-2"
                                (click)="addLicenseButton()"
                                title="{{'Add license'|translate}}">
                                <span class="material-icons" style="font-size: 2.1vh">
                                    add
                                </span>
                            
                            </button> -->
                            <!-- <ng-template #purchaseLicenseBtn>
                                <button class="addbtns d-flex align-items-center p-2"                            
                                (click)="purchaseLicense()"
                                title="{{'Purchase license'|translate}}">
                                    <span class="material-icons" style="font-size: 2.1vh">
                                        add
                                    </span>                                    
                                </button>
                            </ng-template>                     -->
                                         
                    </div>
                    <!-- DATE DOWNLOAD HEADER -->
                    <div class="card-header flex_row_center_spacebetween">
                        <div class="flex_row_center_spacebetween">
                            <select class="form-select selectimportant" [(ngModel)]="pageOption" name="pageOption">
                                <option value="10" class="select_options">10</option>
                                <option value="20" class="select_options">20</option>
                                <option value="30" class="select_options">30</option>
                                <option value="40" class="select_options">40</option>
                                <option value="50" class="select_options">50</option>
                                <option value="60" class="select_options">60</option>
                            </select>
                        </div>
                        <div style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-end;
                    width: 27vh;
                ">
                            <!-- <div class="d-flex flex-row align-items-center" style="padding: 0.4vh 0 0 0">
                                <span class="addlabels">{{'Active'|translate}}</span>
                                <mat-slide-toggle style="padding-left: 1vh"></mat-slide-toggle>
                            </div>
                            <span (click)="getAllLicenses()" class="btn"><img src="/assets/icons/report_refresh_gray.png" alt="refresh"
                                    style="width: 96%" /></span> -->
                            <span class="btn" style="cursor:pointer" (click)="download()"><img src="/assets/icons/report_download_gray.png" alt="download"
                                    style="width: 96%" /></span>
                        </div>
                    </div>
                    <!-- CUSTOMER TABLE -->
                    <!-- {{taskListData | json }} -->
                    <div class="card-body common_scroller fixed_height p-0">
                        <table id="report-table" class="table table-borderless m-0">
                            <thead class="bg-light">
                                <tr>
                                    <th class="table_head_text">{{'Task ID'|translate}}</th>
                                    <th class="table_head_text">{{'Client Name'|translate}}</th>
                                    <th class="table_head_text">{{'Task Type'|translate}}</th>
                                    <th class="table_head_text">{{'Address'|translate}}</th>
                                    <th class="table_head_text">{{'Status'|translate}}</th>
                                    <th class="table_head_text">{{'Driver Name'|translate}}</th>
                                    <th class="table_head_text">{{'Created On'|translate}}</th>
                                    <th class="table_head_text">{{'Start Time'|translate}}</th>
                                    <th class="table_head_text">{{'End Time'|translate}}</th>
                                    <th class="table_head_text">{{'Distance'|translate}}</th>
                                    <th class="table_head_text">{{'Duration'|translate}}</th>
                                    <th class="table_head_text">{{'Shift Timing'|translate}}</th>
                                    <th class="table_head_text">{{'Remarks'|translate}}</th>
                                </tr>
                            </thead>
    
                            <tbody *ngIf="taskListData.length">
                                <tr *ngFor="let customer of taskListData  | searchPipe : form.value.searchValue |  paginate : {
                                     itemsPerPage: pageOption,
                                      currentPage: page,
                                     totalItems: (taskListData  | searchPipe : form.value.searchValue).length
                                      };let i=index">
                                    <td class="table_data">{{ customer.id ? customer.id : '' }}</td>
                                    <td class="table_data">{{customer.clientid}}</td>
                                    <td class="table_data">{{customer.type }}</td>
                                    <td class="table_data">{{ customer.pickuplocation }}</td>
                                    <td class="table_data">{{ customer.status.charAt(0).toUpperCase() + customer.status.slice(1) }}</td>
                                    <td class="table_data">{{ customer.attributes.driverName }}</td>
                                    <td class="table_data">{{ customer.date | date: 'dd/MM/yyyy hh:mm a' }}</td>
                                    <td class="table_data">{{ customer.actualstarttime?(customer.actualstarttime | date: 'dd/MM/yyyy hh:mm a'):'N/A' }}</td>
                                    <td class="table_data">{{ customer.actualendtime ? (customer.actualendtime| date: 'dd/MM/yyyy hh:mm a'):'N/A' }}</td>
                                    <td class="table_data">{{ customer.distanceInKm ? customer.distanceInKm :'N/A'}}</td>
                                    <td class="table_data">{{customer.duration ? customer.duration:'N/A'}}</td>
                                    <td class="table_data">{{ customer.attributes.Shift_Timing }}</td>
                                    <td class="table_data">{{ customer.attributes.remarks ? customer.attributes.remarks : 'N/A'}}</td>
                                     
                                    <!-- <td class="table_data">
                        <div
                        class="btn btn-primary btn-sm mx-1"  
                        (click)="edtUser(customer)"
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop"
                        >
                        <i class="fa fa-edit"></i>
                        </div>
                        <div
                        class="btn btn-danger btn-sm mx-1"
                        (click)="deleteUser(customer.id)"
                        >
                        <i class="fa fa-trash"></i>
                        </div>
                        
                    </td> -->
                                </tr>
                            </tbody>
    
                            <tbody *ngIf="!taskListData.length">
                                <tr>
                                    <td colspan="7">
                                        <div class="d-flex justify-content-center align-items-center" style="height: 48vh">
                                            <img src="/assets/images/datanotfound.png" alt="NO DATA AVAILABLE IN TABLE" />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div *ngIf="taskListData.length" class="flex_row_center_spacebetween"
                        style="padding:1.5vh 2vh;border-top: 1px solid #E3E7EC;">
                        <div>{{'Showing'|translate}} {{page}} {{'to'|translate}} {{(taskListData | searchPipe : form.value.searchValue).length/pageOption |
                            number: '1.0-0'}} {{'of'|translate}}
                            {{(taskListData | searchPipe : form.value.searchValue).length}} {{'entries'|translate}}</div>
                        <pagination-controls (pageChange)="page = $event"></pagination-controls>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid" modeldata *ngIf="addMode">
            <form name="licensesForm" >
                <div class="row">
                    <div class="col-12 col-md-6" *ngIf="superAdmin">
                        <ng-container *ngIf="superAdmin">
                            <label for="userId" class="">{{'Dealer'|translate}}</label>
                            <div class="search-dealer bg-light px-1 py-1">
                            <mat-form-field  class="example-full-width" appearance="fill">
                            
                                <input  type="text" placeholder="Select Dealer" aria-label="Number" matInput 
                                [formControl]="myDealerControl"
                                  [matAutocomplete]="auto" />
                                <mat-autocomplete autoActiveFirstOption [displayWith]="displayFn" #auto="matAutocomplete"
                                  (optionSelected)="dealerSelected($event.option.value)">
                                  <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                    {{option.name}}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                        </div>
                        <span class="text-danger validation" *ngIf="errors?.userId">
                                {{ errors.userId }}
                            </span>
                        </ng-container>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group pb-2">
                            <label for="name" class="pb-2">{{'Single Unit Amount'|translate}}</label>
                            <input disabled type="number" [value]="addLicensesForm.amount" name="amount"
                                class="form-control " id="amount" aria-describedby="amount" />
                            <span class="text-danger validation" *ngIf="errors?.amount">
                                {{ errors.amount }}
                            </span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group pb-2">
                            <label for="name" class="pb-2">{{'Currency'|translate}}</label>
                            <input name="currency" type="text" disabled [value]="addLicensesForm.currency"
                                class="form-control " id="identifier" aria-describedby="identifier" />
                            <span class="text-danger validation" *ngIf="errors?.currency">
                                {{ errors.currency }}
                            </span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group pb-2">
                            <label for="name" class="pb-2">{{'Count'|translate}}</label>
                            <input name="devicecount" (change)="onChangeCount()" type="number" min="0" max="100" [(ngModel)]="addLicensesForm.devicecount"
                                class="form-control " id="identifier" aria-describedby="identifier" />
                            <span class="text-danger validation" *ngIf="errors?.devicecount">
                                {{ errors.devicecount }}
                            </span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group pb-2">
                            <label for="name" class="pb-2">{{'Tax'|translate}} (%)</label>
                            <input disabled type="number" min="0"  [(ngModel)]="addLicensesForm.tax" name="tax"
                                class="form-control " id="identifier" aria-describedby="identifier" />
                            <span class="text-danger validation" *ngIf="errors?.tax">
                                {{ errors.tax }}
                            </span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group pb-2">
                            <label for="name" class="pb-2">{{'Total'|translate}}</label>
                            <input disabled type="number" min="0"  [(ngModel)]="addLicensesForm.total" name="total"
                                class="form-control " id="identifier" aria-describedby="identifier" />
                            <span class="text-danger validation" *ngIf="errors?.total">
                                {{ errors.total }}
                            </span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6" *ngIf="superAdmin">
                        <div *ngIf="superAdmin" class="form-group pb-2">
                            <label for="name" class="pb-2">{{'Status'|translate}}</label>
                            <select
                            name="status"
                            class="form-control"
                            [(ngModel)]="addLicensesForm.status"
                            
                            >
                            <option value="" class="select_options">Select</option>
                            <option value="Completed" class="select_options">Completed</option>
                            <option value="Pending" class="select_options">Pending</option>
                            </select>
                            <span class="text-danger validation" *ngIf="errors?.status">
                                {{ errors.status }}
                            </span>
                        </div>
                    </div>
                    
                </div>             
                <button type="button" class="btn btn-primary" (click)="onOrderPlace()"> {{superAdmin ? ('Save' |translate) : ('Checkout'|translate)}}</button>
                <button type="button" class="btn btn-secondary ms-3" (click)="onCancelClick()"> Cancel </button>
            </form>
        </div>
    </app-common-modal-popup>
    
    <!-- <div class="modal" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content" style="border: none">
                <div class="modal-header addtriphead">
                    <div class="headtext">
                        {{superAdmin ? ('Add license'|translate):('Purchase license'|translate)}}
                    </div>
                    <button type="button" class="btnclose" data-bs-dismiss="modal" aria-label="Close">
                        <span class="material-icons"> close </span>
                    </button>
                </div>
                <div class="modal-body modal-bodys" style="padding: 1vh 4vh">
                    <form name="licensesForm" >
                        
                        <ng-container *ngIf="superAdmin">
                            <label for="userId" class="">{{'Dealer'|translate}}</label>
                        <div class="search-dealer">
                            <mat-form-field  class="example-full-width" appearance="fill">
                            
                                <input  type="text" placeholder="Select Dealer" aria-label="Number" matInput 
                                [formControl]="myDealerControl"
                                  [matAutocomplete]="auto" />
                                <mat-autocomplete autoActiveFirstOption [displayWith]="displayFn" #auto="matAutocomplete"
                                  (optionSelected)="dealerSelected($event.option.value)">
                                  <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                    {{option.name}}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                        </div>
                        <span class="text-danger validation" *ngIf="errors?.userId">
                                {{ errors.userId }}
                            </span>
                        </ng-container>
                        
                        <div class="form-group pb-2">
                            <label for="name" class="pb-2">{{'Single Unit Amount'|translate}}</label>
                            <input disabled type="number" [value]="addLicensesForm.amount" name="amount"
                                class="form-control " id="amount" aria-describedby="amount" />
                            <span class="text-danger validation" *ngIf="errors?.amount">
                                {{ errors.amount }}
                            </span>
                        </div>
                        <div class="form-group pb-2">
                            <label for="name" class="pb-2">{{'Currency'|translate}}</label>
                            <input name="currency" type="text" disabled [value]="addLicensesForm.currency"
                                class="form-control " id="identifier" aria-describedby="identifier" />
                            <span class="text-danger validation" *ngIf="errors?.currency">
                                {{ errors.currency }}
                            </span>
                        </div>
                        <div class="form-group pb-2">
                            <label for="name" class="pb-2">{{'Count'|translate}}</label>
                            <input name="devicecount" (change)="onChangeCount()" type="number" min="0" max="100" [(ngModel)]="addLicensesForm.devicecount"
                                class="form-control " id="identifier" aria-describedby="identifier" />
                            <span class="text-danger validation" *ngIf="errors?.devicecount">
                                {{ errors.devicecount }}
                            </span>
                        </div>
                        <div class="form-group pb-2">
                            <label for="name" class="pb-2">{{'Tax'|translate}} (%)</label>
                            <input disabled type="number" min="0"  [(ngModel)]="addLicensesForm.tax" name="tax"
                                class="form-control " id="identifier" aria-describedby="identifier" />
                            <span class="text-danger validation" *ngIf="errors?.tax">
                                {{ errors.tax }}
                            </span>
                        </div>
                        <div class="form-group pb-2">
                            <label for="name" class="pb-2">{{'Total'|translate}}</label>
                            <input disabled type="number" min="0"  [(ngModel)]="addLicensesForm.total" name="total"
                                class="form-control " id="identifier" aria-describedby="identifier" />
                            <span class="text-danger validation" *ngIf="errors?.total">
                                {{ errors.total }}
                            </span>
                        </div>
                        <div *ngIf="superAdmin" class="form-group pb-2">
                            <label for="name" class="pb-2">{{'Status'|translate}}</label>
                            <select
                            name="status"
                            class="form-control"
                            [(ngModel)]="addLicensesForm.status"
                            
                            >
                            <option value="" class="select_options">Select</option>
                            <option value="Completed" class="select_options">Completed</option>
                            <option value="Pending" class="select_options">Pending</option>
                            </select>
                            <span class="text-danger validation" *ngIf="errors?.status">
                                {{ errors.status }}
                            </span>
                        </div>
                        <button type="button" class="btn btn-primary" (click)="onOrderPlace()"> {{superAdmin ? ('Save' |translate) : ('Checkout'|translate)}}</button>
                    </form>
                </div>
            </div>
        </div>
    </div> -->
    <div style="display:none" class="novopay-response-modal modal fade" role="dialog"     [ngClass]="{'show': showModal}"
      id="response-modal"
        [ngStyle]="{'display': 'none'}">
        {{response}}
        </div>
    
    <div style="display: none" class="novopay-response-modal modal fade" role="dialog"     [ngClass]="{'show': showModal}"
      id="razorpay-response"
        [ngStyle]="{'display': 'none'}">
        {{razorpayResponse}}
        </div>

        <div id="htmlString-container" #pdfTable [innerHtml]="htmlString" style="display: none;"></div>